import { render, staticRenderFns } from "./bottom-info.vue?vue&type=template&id=96f7d9dc&scoped=true"
import script from "./bottom-info.vue?vue&type=script&lang=js"
export * from "./bottom-info.vue?vue&type=script&lang=js"
import style0 from "./bottom-info.vue?vue&type=style&index=0&id=96f7d9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f7d9dc",
  null
  
)

export default component.exports